var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    { staticClass: "view-lots" },
    [
      _c(
        "ui-heading",
        { attrs: { title: "Percelen", icon: "magicon-resize-plus-3" } },
        [
          _vm.$can("MUTATE_PARCELS")
            ? _c(
                "ui-button",
                {
                  attrs: {
                    color: "positive",
                    icon: "magicon-plus",
                    route: "parcel-add",
                  },
                },
                [_vm._v("Perceel toevoegen")]
              )
            : _vm._e(),
          _c("ui-searchbar", {
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c(
        "ui-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            clickable: "",
            placeholder: _vm.parcels && !_vm.parcels.items.length,
            total: _vm.$safe("parcels.totalCount"),
            visible: _vm.paging.limit,
          },
          on: { page: _vm.switchPage },
        },
        [
          _c(
            "ui-table-header",
            [
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "parcelLocationId" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Naam")]
              ),
              _c("ui-th", { attrs: { weight: "2" } }, [
                _vm._v("Perceelnummer"),
              ]),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "alias" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Alias")]
              ),
              _c("ui-th", { attrs: { weight: "2" } }, [
                _vm._v("Perceelvakken"),
              ]),
              _c("ui-th", { attrs: { weight: "2" } }, [_vm._v("Oppervlakte")]),
              _c("ui-th", { attrs: { weight: "1" } }),
            ],
            1
          ),
          _vm._l(_vm.$safe("parcels.items"), function (parcel) {
            return _c("ui-tr", { key: parcel.id, attrs: { click: "edit" } }, [
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("empty")(_vm.$safe(parcel, "parcelLocation.name"))
                  )
                ),
              ]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("empty")(_vm.$safe(parcel, "parcelLocation.number"))
                  )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm._f("empty")(parcel.alias)))]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("empty")(_vm.$safe(parcel, "sections.itemCount"))
                  )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm._f("number")(parcel.size)) + " ha")]),
              _c(
                "td",
                {
                  staticClass: "actions",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm.$can("MUTATE_PARCELS")
                    ? _c("ui-link", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Wijzigen",
                            expression: "'Wijzigen'",
                          },
                        ],
                        attrs: {
                          icon: "magicon-edit",
                          action: "edit",
                          to: {
                            name: "parcel-edit",
                            params: { id: parcel.id },
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.$can("MUTATE_PARCELS")
                    ? _c("ui-link", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Verwijderen",
                            expression: "'Verwijderen'",
                          },
                        ],
                        attrs: { icon: "magicon-trash" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteParcel(parcel.id)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }